{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "https://www.w3.org/ns/pub-schema/manifest/module/urls.schema.json",
  "title": "URLs",
  "oneOf": [
    {
      "type": "string",
      "format": "uri-reference"
    },
    {
      "type": "array",
      "items": {
        "type": "string",
        "format": "uri-reference"
      }
    }
  ]
}
